export default __webpack_public_path__ + "static/media/external_link.7ee21623.svg";